import { TextField, type TextFieldProps } from '@mui/material';

export type Props = TextFieldProps & {};

export const Input = (props: Props) => {
  const { label, required, ...other } = props;

  return <TextField variant='standard' label={`${label || ''}${required ? ' *' : ''}`} fullWidth {...other} />;
};
